// import PropTypes from 'prop-types';


import RFFNumberInputField from '../../form/RFFNumberInputField';
import RFFInputField from '../../form/RFFInputField';
// import RFFRadio from '../../form/RFFRadio';
import RFFSelectField from '../../form/RFFSelect';
import RFFSelectCountryField from '../../form/RFFSelectCountry';
import RFFSelectStateProvField from '../../form/RFFSelectSateProv';
import msgs from '../../../config/messages';
// import State from '../../../config/fiftyStates.json';
// import States from '../../../../config/fiftyStates_copy.json';
// import CandianProvinces from '../../../../config/candianProvinces.json';
// import Countries from '../../../../config/countries.json';


// import { isCageEditable } from '../../../utils/validationUtils';

/*
import {
  required,
  isCageCode,
  isPhoneNumber,
  isEmail,
  isUSZipCode,
  composeValidators,
} from '../../../utils/validationUtils';

import {
  emailIsValidAndUnsassigned,
  cageIsValidAndUnassigned,
} from '../../../utils/asyncValidations';
*/

import { formatToUppercase, ArrayFormat, AssArrayFormat } from '../../../utils/formats';

export const orgDetailsConfig = [
  {
    name: 'organizationType',
    label: 'Organization Type',
    component: RFFSelectField,
    options: [
      {
        text: 'Industry',
        value: 'common',
      },
      {
        text: 'Government',
        value: 'government',
      },
    ],
    disabled: true,
    // isRequired: true,    
  },

  {
    name: 'cageCode',
    id: 'cageCode',
    label: msgs.OrganizationForm.cageCode,
    component: RFFInputField,
    disabled: true,
    // isRequired: true,
    // validate: composeValidators(required, isCageCode, cageIsValidAndUnassigned),
    format: formatToUppercase,
  },

  {
    name: 'name',
    label: 'Organization Name',
    component: RFFInputField,
    //  disabled: true,
    // isRequired: true,
    // validate: required,
  },
  {
    name: 'industryType',
    label: msgs.OrganizationForm.industryType,
    component: RFFInputField,
    disabled: true,
    format: ArrayFormat,
  },
  {
    name: 'associationValidations',
    label: msgs.OrganizationForm.associationValidations,
    component: RFFInputField,
    disabled: true,
    format: AssArrayFormat,
  },
  {
    name: 'address1',
    label: msgs.OrganizationForm.address1,
    component: RFFInputField,
    //  disabled: true,
    // isRequired: true,
    // validate: required,
  },
  {
    name: 'address2',
    label: msgs.OrganizationForm.address2,
    component: RFFInputField,
    //  disabled: true,
  },
  {
    name: 'address3',
    label: msgs.OrganizationForm.address3,
    component: RFFInputField,
    //  disabled: true,
  },
  {
    name: 'city',
    label: msgs.OrganizationForm.city,
    component: RFFInputField,
    //  disabled: true,
    // isRequired: true,
    // validate: required,
  },

  {
    name: 'cntry',
    label: 'Country',
    component: RFFSelectCountryField,
    // onChangeCountry: props.onChangeCountry,
    // options: createOptions(State),
    // disabled: true,
    // isRequired: true,
    // validate: isUSZipCode,
  },

  {
    name: 'state',
    label: msgs.OrganizationForm.state,
    component: RFFSelectStateProvField,
    //  disabled: true,
    // isRequired: true,
    // validate: required,
    // options: createOptions(State),
  },
  {
    name: 'zipCode',
    label: msgs.OrganizationForm.zipcode,
    component: RFFInputField,
    // disabled: true,
    // isRequired: true,
    // validate: isUSZipCode,
  },

  {
    name: 'websiteUrl',
    label: msgs.OrganizationForm.websiteUrl,
    component: RFFInputField,
    //  disabled: true,
  },

];

export const contactConfig = [
  {
    name: 'pointOfContact',
    label: 'Full Name',
    component: RFFInputField,
    // disabled: true,
    // isRequired: true,
    // validate: required,
  },
  {
    name: 'email',
    label: 'Email',
    component: RFFInputField,
    // disabled: false,
    // isRequired: true,
    // validate: composeValidators(required, isEmail, emailIsValidAndUnsassigned),
  },
  {
    name: 'phoneNumber',
    label: 'Phone',
    component: RFFNumberInputField,
    // disabled: true,
    // isRequired: true,
    // validate: composeValidators(required, isPhoneNumber),
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/NewOrganizationForm/formConfig.jsx